"use strict";

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuctions = void 0;

var tslib_1 = require("tslib");

var react_1 = require("react");

var swr_1 = tslib_1.__importDefault(require("swr"));

var NFTFetchContext_1 = require("../context/NFTFetchContext");

var ErrorUtils_1 = require("../fetcher/ErrorUtils");
/**
 * Fetches on-chain NFT auction data for the given curator
 *
 * @param curators
 * @param approved
 * @returns useNFTType hook results include loading, error, and data (ReserveAuctionPartialFragment).
 */


function useAuctions() {
  var curators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var approved = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options.onErrorRetry = ErrorUtils_1.onErrorRetry;
  var fetcher = react_1.useContext(NFTFetchContext_1.NFTFetchContext);
  var queryKey = JSON.stringify({
    type: 'useAuctions',
    curators: curators,
    approved: approved
  });

  var _swr_1$default = swr_1.default(queryKey, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
      var _JSON$parse, curators, approved;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _JSON$parse = JSON.parse(query), curators = _JSON$parse.curators, approved = _JSON$parse.approved;
              _context.next = 3;
              return fetcher.fetchReserveAuctions(curators.map(function (curator) {
                return curator.toLowerCase();
              }), approved);

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), options),
      data = _swr_1$default.data,
      error = _swr_1$default.error;

  return {
    loading: !error && !data,
    error: error,
    data: data
  };
}

exports.useAuctions = useAuctions;